import { metaPath } from 'util/metaPath'

export interface PreNatalDumModel {
  dum: LocalDate | null
}

export const meta = metaPath<PreNatalDumModel>()
